module.exports = __webpack_public_path__ + "img/pro_1.1ac51840.jpg";